import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OEEquineHoofTargetType, OEEquineHoofTargets, OEEquineHoofFeatureAccess, OEEquineHoofStartSelectionData} from './oe-equine-hoof-model';

export default class OEEquineHoofCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OEEquineHoofTargetType.anatomy]:   {icon: OEIconCodes.equineHoof.anatomyTarget, titleId: 'target_menu_anatomy'},
            [OEEquineHoofTargetType.dynamic]:   {icon: OEIconCodes.equineHoof.dynamicTarget, titleId: 'target_menu_hoof_dynamic'},
            [OETarget.effigosExplorerHelp]:     {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        let targetTypes = [OEEquineHoofTargetType.anatomy, OEEquineHoofTargetType.dynamic, OETarget.effigosExplorerHelp];

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OEEquineHoofTargets}
                featureAccess={OEEquineHoofFeatureAccess}
                startSelectionData={OEEquineHoofStartSelectionData}
            />
        );
    }
}